import { z } from 'zod';

const JwtExpPayloadZod = z.object({
    exp: z.number(),
});

export const decodeJwtExp = (token: string): number | null => {
    const chunks = token.split('.');

    if (chunks.length !== 3) {
        return null;
    }

    const payload = chunks[1];

    if (payload === undefined || payload === '') {
        return null;
    }

    try {
        const parsed = JSON.parse(atob(payload));
        const result = JwtExpPayloadZod.safeParse(parsed);

        if (!result.success) {
            return null;
        }

        return result.data.exp;
    } catch {
        return null;
    }
};

export const getBetGliderLaunchUrlExpiry = (launchUrl: string): number | null => {
    try {
        const url = new URL(launchUrl);
        const ott = url.searchParams.get('ott');

        if (ott === null || ott === '') {
            return null;
        }

        return decodeJwtExp(ott);
    } catch {
        return null;
    }
};
